<template>

    <div class="mb-3 col-12 order-1 order-lg-2">
        <div class="card">
            <div class="card-body pb-0">
                <div class="row">
                    <div class="col-12 mb-4">
                        <h5 class="fw-bold">{{ $t('Kontodetaljer') }}</h5>
                    </div>
                </div>
            </div>
            <SaleList></SaleList>
        </div>
    </div>
</template>

<script setup>
    import SaleList from './SaleList'
</script>